var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import FormattedDateShort from '@/shared/components/FormattedDateShort';
import { DeleteIcon } from '@/shared/components/Icons';
import { AccessTokenQueryKey } from '@/shared/hooks/accessTokens/queryKey';
import { useGetAccessTokens } from '@/shared/hooks/accessTokens/useGetAccessTokens';
import { useRevokeAccessToken } from '@/shared/hooks/accessTokens/useRevokeAccessToken';
import { ModalType, useModalContext } from '@/shared/providers/ModalProvider';
import { useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import FormattedDateTime from '@/shared/components/FormattedDateTime';
import SimplePanel from '@/shared/components/SimplePanel';
import moment from 'moment';
import { messages } from './accessTokenMessages';
var AccessTokensContainer = function () {
    var queryClient = useQueryClient();
    var accessTokens = useGetAccessTokens();
    var revokeAccessToken = useRevokeAccessToken().revokeAccessToken;
    var setShowModalInfo = useModalContext().setShowModalInfo;
    var intl = useIntl();
    var createNewAccessToken = function () { return setShowModalInfo({ modalType: ModalType.CreatePat }); };
    var deleteProps = function (key) { return ({
        onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                setShowModalInfo({
                    modalType: ModalType.YesNo,
                    title: intl.formatMessage(messages.RevokeAccessToken),
                    message: intl.formatMessage(messages.RevokeAccessTokenConfirmation),
                    onSave: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, revokeAccessToken({ key: key })];
                                case 1:
                                    _a.sent();
                                    return [4 /*yield*/, queryClient.invalidateQueries([AccessTokenQueryKey.AccessTokens])];
                                case 2:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); },
                });
                return [2 /*return*/];
            });
        }); },
    }); };
    return (_jsxs("div", __assign({ className: "dskb" }, { children: [_jsx(SimplePanel, { article: "8331100368924", title: intl.formatMessage(messages.AccessTokens) }), _jsx("div", __assign({ className: "row" }, { children: _jsxs("div", __assign({ className: "col-md-12" }, { children: [_jsxs("table", __assign({ className: "table table-grid" }, { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: intl.formatMessage(messages.Name) }), _jsx("th", { children: intl.formatMessage(messages.Expires) }), _jsx("th", { children: intl.formatMessage(messages.CreatedAt) }), _jsx("th", { children: intl.formatMessage(messages.Actions) })] }) }), _jsx("tbody", { children: (accessTokens === null || accessTokens === void 0 ? void 0 : accessTokens.data) &&
                                        accessTokens.data.map(function (accessToken) { return (_jsxs("tr", { children: [_jsx("td", { children: accessToken.name }), _jsx("td", { children: _jsx(FormattedDateShort, { value: accessToken.expires }) }), _jsx("td", { children: _jsx(FormattedDateTime, { value: moment(accessToken.created)
                                                            .utc(true)
                                                            .toISOString() }) }), _jsx("td", { children: _jsx(DeleteIcon, __assign({ intl: intl }, deleteProps(accessToken.key))) })] }, accessToken.key)); }) })] })), _jsxs("button", __assign({ className: "btn btn-default btn-sticky btn-sticky-left", type: "button", onClick: createNewAccessToken }, { children: [_jsx("i", { className: "fa fa-plus" }), _jsx("span", __assign({ className: "margin5L" }, { children: intl.formatMessage(messages.AddToken) }))] }))] })) }))] })));
};
export default AccessTokensContainer;
